import { render } from "./FormInvoiceSage.vue?vue&type=template&id=4932629c&scoped=true"
import script from "./forminvoicesage.view.js?vue&type=script&lang=js&external"
export * from "./forminvoicesage.view.js?vue&type=script&lang=js&external"

import "./forminvoicesage.css?vue&type=style&index=0&id=4932629c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4932629c"]])

export default __exports__